import React, { useContext, useEffect } from "react";
import Logo from "../Logo/Logo";
import './Header.css'
import { Menu } from "../../Context/MenuOpen/MenuContext";
import { useTranslation } from "react-i18next";
const Header = () => {
  const { t , i18n} = useTranslation()
  const menu = useContext(Menu);
  const isOpen = menu.isOpen
  const setIsOpen = menu.setIsOpen
  const handelChangeLanguegae =(value)=>{
    i18n.changeLanguage(value);
    // window.location.reload();

    document.documentElement.setAttribute("dir" , value === 'ar' ? 'rtl' : 'ltr')
  }
  useEffect(()=>{
    document.documentElement.setAttribute("dir" , i18n.language === 'ar' ? 'rtl' : 'ltr')
    
  },[i18n.language])
  return (
    <div className="custom-head ">

    <div className="Header ">
      <header className="flex px-10 justify-between items-center h-20">
        <Logo  class="w-[95px] md:w-[120px]" />
        <div className="flex items-center gap-4">
        <select value={i18n.language} onChange={(e)=>handelChangeLanguegae(e.target.value)} className="link">
        <option value="en">EN</option>
        <option value="ar">AR</option>
      </select>
        <div className="menu" onClick={()=>setIsOpen(prev=> !prev)}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        </div>

      </header>
    </div>
    </div>
  );
};

export default Header;
